import _ from 'lodash';

import { PDF_CONTENT_TYPE_PREFIX } from './IntakeSegmentPreview.constants';

/**
 * Determine if the given MIME content-type represents a PDF.
 *
 * @param {string|null|undefined} contentType
 * @returns {boolean}
 */
export const isPdfContentType = contentType =>
  _.isString(contentType) && contentType.startsWith(PDF_CONTENT_TYPE_PREFIX);

/**
 * Build an object URL from an ArrayBuffer for use in an `<img>` src.
 * The caller is responsible for calling URL.revokeObjectURL when done.
 *
 * @param {ArrayBuffer} buffer
 * @param {string} contentType
 * @returns {string}
 */
export const buildObjectUrl = (buffer, contentType) => {
  const blob = new Blob([buffer], { type: contentType });

  return URL.createObjectURL(blob);
};

/**
 * Build the lightbox title for a given page within a segment.
 *
 * @param {string|null} segmentName - human label for the document type (or null)
 * @param {string|null} sourceFileName - source file name (e.g. "combined.pdf")
 * @param {number} pageNumInSource - 1-based page number in the source file
 * @param {number} totalSegmentPages - total number of pages in this segment
 * @returns {string}
 */
export const buildLightboxTitle = (
  segmentName,
  sourceFileName,
  pageNumInSource,
  totalSegmentPages,
) => {
  const docLabel = segmentName ?? 'Document';
  const fileLabel = sourceFileName ? ` — ${sourceFileName}` : '';
  const pageLabel = ` · page ${pageNumInSource} of ${totalSegmentPages}`;

  return `${docLabel}${fileLabel}${pageLabel}`;
};
